import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { UploadFileRequest } from '../../types/interfaces/file';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/files`;

export const uploadFile = async (uploadInfo: UploadFileRequest): Promise<any> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = BASE_URL + '/';

  const formData = new FormData();
  formData.append('accountId', uploadInfo.accountId.toString());
  if (uploadInfo.projectId)
    formData.append('projectId', uploadInfo.projectId.toString());
  if (uploadInfo.activityId)
    formData.append('activityId', uploadInfo.activityId.toString());
  if (uploadInfo.procedureId)
    formData.append('procedureId', uploadInfo.procedureId.toString());
  if (uploadInfo.stageId)
    formData.append('stageId', uploadInfo.stageId.toString());
  formData.append('fileContent', uploadInfo.file);

  return await axios
    .post<any>(finalURL, formData, {
      headers: {
        'x-access-token': session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
